import styled from 'styled-components';
import { BackgroundColor } from '@pegasus/ui-components/tokens/colors';

export const Wrapper = styled.div`
    display: flex;
    padding: 18px 20px;
    background: ${BackgroundColor.neutral};
`;

export const IconWrapper = styled.div`
    margin-right: 22px;
    padding-top: 4px;
    min-width: 46px;
    width: 46px;
    min-height: 46px;
    height: 46px;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const MessageWrapper = styled.div`
    flex-grow: 1;

    .header {
        text-transform: capitalize;
        margin: 0;
    }
`;

export const SmallPrintWrapper = styled.div`
    margin-top: 16px;

    .small-print {
        margin: 0;
    }
`;
